import { Cart, type ConsumerCheckoutCartsResponse, useShowCart } from '@givebacks/api/store';
import { useSessionStorage } from 'ui/Hooks';

const getStoreItem = (cart: Cart) => cart?.cart_items?.[0]?.store_item;
const getCartItemCount = (cart: Cart) => cart?.cart_items?.length;
/** Returns the cart ids from the checkout */
const getCartIdsFromCheckout = (data?: ConsumerCheckoutCartsResponse) => {
  return data?.checkout.carts.map((cart) => cart.uuid) ?? [];
};
/** Returns the total number of items in the checkout */
const getCartItemCountFromCheckout = (data?: ConsumerCheckoutCartsResponse) => {
  return data?.checkout.carts.reduce((acc, cart) => acc + cart.cart_items.length, 0);
};
/**
 * Returns static information about the carts in the checkout
 * This includes the cart id, the store id
 * and the processed_via
 */
const getCartsInfoFromCheckout = (data?: ConsumerCheckoutCartsResponse) => {
  return data?.checkout.carts.map((cart) => ({
    cartId: cart.uuid,
    storeId: cart.cause_id,
    processed_via: cart.processed_via,
  }));
};

const getPaymentMethodNeeded = (cart: Cart) => cart?.payment_method_needed;

type SessionStorageCheckoutForm = {
  firstName: string;
  lastName: string;
  email: string;
};

const useSessionCheckoutForm = () => {
  const [form, setForm] = useSessionStorage<SessionStorageCheckoutForm | undefined>({
    key: 'checkout-form',
    defaultValue: undefined,
  });
  return {
    setForm,
    form,
  };
};

const useShowIsPaymentMethodNeeded = ({ cartId }: { cartId?: string }) => {
  const { data: paymentMethodNeeded } = useShowCart({
    cartId,
    queryKeyId: 'user',
    select: getPaymentMethodNeeded,
  });

  return { isPaymentMethodNeeded: paymentMethodNeeded };
};

export {
  getCartIdsFromCheckout,
  getCartItemCount,
  getCartItemCountFromCheckout,
  getCartsInfoFromCheckout,
  getStoreItem,
  useSessionCheckoutForm,
  useShowIsPaymentMethodNeeded,
};
